import Employee from '@/models/Employee';
import Employer from '@/models/Employer';

export default class User {
  public employee: Employee = new Employee();
  public employer: Employer = new Employer();
  public isEmployee: boolean;
  public isEmployer: boolean;

  constructor(
    public email?: string | null,
    public displayName?: string | null,
    public photo?: string,
    public updatedAt?: any,
    public lastSignedInAt?: any
  ) {}
}
